document.addEventListener("DOMContentLoaded", (event) => {
  
// Mobile Menu Drawer Start
document.querySelectorAll('.categories-container .tab-title-container .title-block').forEach(function(element) {
  element.addEventListener('click', function() {
    // Remove 'active' class from all siblings
    let siblings = Array.from(this.parentElement.children).filter(child => child !== this);
    siblings.forEach(function(sibling) {
      sibling.classList.remove('active');
    });
    
    // Add 'active' class to clicked element
    this.classList.add('active');
    
    // Remove 'active' class from all content blocks
    document.querySelectorAll('.tab-content-container .content-block').forEach(function(contentBlock) {
      contentBlock.classList.remove('active');
    });
    
    // Add 'active' class to matching content block
    let tabId = this.getAttribute('tab-id');
    let matchingContent = document.querySelector(`[content-tab-id="${tabId}"]`);
    if (matchingContent) {
      matchingContent.classList.add('active');
    }
  });
});

const firstTitleBlock = document.querySelector('.categories-container .tab-title-container .title-block:first-child');
if (firstTitleBlock) {
  firstTitleBlock.click();
}


document.querySelectorAll(".description-accordion .accordian-title").forEach(function(element) {
  element.addEventListener("click", function() {
    // Get the next sibling element
    const nextElement = this.nextElementSibling;
    
    // Toggle the active class
    this.classList.toggle("active");
    
    // Slide toggle animation
    if (nextElement) {
      if (nextElement.style.display === "none" || !nextElement.style.display) {
        // Slide down
        nextElement.style.display = "block";
        const height = nextElement.scrollHeight + "px";
        nextElement.style.height = "0px";
        nextElement.style.overflow = "hidden";
        nextElement.style.transition = "height 300ms ease";
        
        // Force reflow
        nextElement.offsetHeight;
        
        nextElement.style.height = height;
        
        setTimeout(function() {
          nextElement.style.height = "";
          nextElement.style.overflow = "";
          nextElement.style.transition = "";
        }, 300);
      } else {
        // Slide up
        nextElement.style.height = nextElement.scrollHeight + "px";
        nextElement.style.overflow = "hidden";
        nextElement.style.transition = "height 300ms ease";
        
        // Force reflow
        nextElement.offsetHeight;
        
        nextElement.style.height = "0px";
        
        setTimeout(function() {
          nextElement.style.display = "none";
          nextElement.style.height = "";
          nextElement.style.overflow = "";
          nextElement.style.transition = "";
        }, 300);
      }
    }
  });
});
 
  
/*Footer SEO navigation Tab Start*/
document.querySelectorAll('.seo p').forEach(function(element) {
  element.addEventListener('click', function() {
    const allSeoP = document.querySelectorAll('.seo p');
    const clickedElement = this;
    
    // Check if any .seo p element has 'active' class
    const hasActive = Array.from(allSeoP).some(el => el.classList.contains('active'));
    
    if (hasActive) {
      // Remove 'active' from all .seo p elements
      allSeoP.forEach(el => el.classList.remove('active'));
    } else {
      // Add 'active' only to clicked element
      clickedElement.classList.add('active');
    }
    
    // Toggle the matching tab container with animation
    const tabTitle = clickedElement.getAttribute('tab-title');
    const targetElement = document.querySelector(`[tab-container="${tabTitle}"]`);
    
    if (targetElement) {
      // Simple toggle with fade effect (200ms)
      if (targetElement.style.display === 'none' || !targetElement.style.display || getComputedStyle(targetElement).display === 'none') {
        // Show with fade in
        targetElement.style.display = 'block';
        targetElement.style.opacity = '0';
        targetElement.style.transition = 'opacity 200ms ease';
        
        // Force reflow
        targetElement.offsetHeight;
        
        targetElement.style.opacity = '1';
        
        setTimeout(function() {
          targetElement.style.transition = '';
        }, 200);
      } else {
        // Hide with fade out
        targetElement.style.transition = 'opacity 200ms ease';
        targetElement.style.opacity = '0';
        
        setTimeout(function() {
          targetElement.style.display = 'none';
          targetElement.style.opacity = '';
          targetElement.style.transition = '';
        }, 200);
      }
    }
  });
});

document.querySelectorAll('.about-us p').forEach(function(element) {
  element.addEventListener('click', function() {
    const allAboutUsP = document.querySelectorAll('.about-us p');
    const clickedElement = this;
    
    // Check if any .about-us p element has 'active' class
    const hasActive = Array.from(allAboutUsP).some(el => el.classList.contains('active'));
    
    if (hasActive) {
      // Remove 'active' from all .about-us p elements
      allAboutUsP.forEach(el => el.classList.remove('active'));
    } else {
      // Add 'active' only to clicked element
      clickedElement.classList.add('active');
    }
    
    // Toggle the matching footer tab container with animation
    const footerTabTitle = clickedElement.getAttribute('footer-tab-title');
    const targetElement = document.querySelector(`[footer-tab-container="${footerTabTitle}"]`);
    
    if (targetElement) {
      // Simple toggle with fade effect (200ms)
      if (targetElement.style.display === 'none' || !targetElement.style.display || getComputedStyle(targetElement).display === 'none') {
        // Show with fade in
        targetElement.style.display = 'block';
        targetElement.style.opacity = '0';
        targetElement.style.transition = 'opacity 200ms ease';
        
        // Force reflow
        targetElement.offsetHeight;
        
        targetElement.style.opacity = '1';
        
        setTimeout(function() {
          targetElement.style.transition = '';
        }, 200);
      } else {
        // Hide with fade out
        targetElement.style.transition = 'opacity 200ms ease';
        targetElement.style.opacity = '0';
        
        setTimeout(function() {
          targetElement.style.display = 'none';
          targetElement.style.opacity = '';
          targetElement.style.transition = '';
        }, 200);
      }
    }
  });
}); 
  

/*Footer SEO navigation Tab End*/


/* Main Navigation Acc icon dropdown Start*/ 

})// document Load end


document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll(".timeline .timeline-block .item .circle-line").forEach(function(element) {
  element.addEventListener("click", function() {
    // Remove "open" class from all content elements
    document.querySelectorAll(".timeline .timeline-block .item .content").forEach(function(content) {
      content.classList.remove("open");
    });
    
    // Remove "active" class from all circle-line elements
    document.querySelectorAll(".timeline .timeline-block .item .circle-line").forEach(function(circleLine) {
      circleLine.classList.remove("active");
    });
    
    // Remove "zoom" class from all img elements
    document.querySelectorAll(".timeline .timeline-block .item img").forEach(function(img) {
      img.classList.remove("zoom");
    });
    
    // Add "zoom" class to the img inside sibling .image element
    const imageSibling = Array.from(this.parentElement.children).find(child => child.classList.contains('image'));
    if (imageSibling) {
      const img = imageSibling.querySelector('img');
      if (img) {
        img.classList.add("zoom");
      }
    }
    
    // Add "open" class to next sibling element
    if (this.nextElementSibling) {
      this.nextElementSibling.classList.add("open");
    }
    
    // Add "active" class to clicked element
    this.classList.add("active");
    
    // Add "img-zoom" class to parent's parent timeline-block
    const timelineBlock = this.closest(".timeline-block");
    if (timelineBlock) {
      timelineBlock.classList.add("img-zoom");
    }
  });
});


document.querySelectorAll(".timeline .timeline-block .item .image").forEach(function(element) {
  element.addEventListener("click", function() {
    // Remove "open" class from all content elements
    document.querySelectorAll(".timeline .timeline-block .item .content").forEach(function(content) {
      content.classList.remove("open");
    });
    
    // Remove "active" class from all circle-line elements
    document.querySelectorAll(".timeline .timeline-block .item .circle-line").forEach(function(circleLine) {
      circleLine.classList.remove("active");
    });
    
    // Remove "zoom" class from all img elements
    document.querySelectorAll(".timeline .timeline-block .item img").forEach(function(img) {
      img.classList.remove("zoom");
    });
    
    // Add "zoom" class to the img child of clicked element
    const img = this.querySelector('img');
    if (img) {
      img.classList.add("zoom");
    }
    
    // Add "open" class to sibling .content element
    const contentSibling = Array.from(this.parentElement.children).find(child => child.classList.contains('content'));
    if (contentSibling) {
      contentSibling.classList.add("open");
    }
    
    // Add "active" class to sibling .circle-line element
    const circleLineSibling = Array.from(this.parentElement.children).find(child => child.classList.contains('circle-line'));
    if (circleLineSibling) {
      circleLineSibling.classList.add("active");
    }
    
    // Add "img-zoom" class to parent's parent timeline-block
    const timelineBlock = this.closest(".timeline-block");
    if (timelineBlock) {
      timelineBlock.classList.add("img-zoom");
    }
  });
});
})


document.addEventListener("DOMContentLoaded", (event) => {
  
  document.querySelectorAll('.benefits-coupons-container .content-block .content-copy button').forEach(function(element) {
  element.addEventListener('click', function() {
    // Get the text from sibling h2 element
      const h2Sibling = Array.from(this.parentElement.children).find(child => child.tagName === 'H2');
      const coupcode = h2Sibling ? h2Sibling.textContent : '';
      
      // Get the button text
      const btnText = this.textContent;
      
      // Call the copyToClipboard function with the same parameters
      copyToClipboard(coupcode, this, btnText);
    });
  });

  document.querySelectorAll('.benefits-coupons-container .coupon-content .btn-with-content a').forEach(function(element) {
  element.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Get the clicked button text
    const selectedBtnText = this.textContent;
    
    // Find the parent .benefits-coupons-container .coupon-content element
    const grandParent1 = this.closest('.benefits-coupons-container .coupon-content');
    
    if (grandParent1) {
      const parent = grandParent1.parentElement;
      const allSiblings = Array.from(parent.children).filter(child => child !== grandParent1);
      
      // Search through all siblings for the h2 element
      let findDiscount = '';
      for (let i = 0; i < allSiblings.length; i++) {
        const h2Element = allSiblings[i].querySelector('.content-block .content-copy h2');
        if (h2Element) {
          findDiscount = h2Element.textContent;
          break;
        }
      }
      
      // Call copyToClipboard with the found values
      copyToClipboard(findDiscount, this, selectedBtnText);
    }
  });
});


  function copyToClipboard(couponCode, selectedElement, btnText) {
    // Create a hidden input element
    const tempInput = document.createElement('input');
    
    // Add the input element to the DOM
    document.body.appendChild(tempInput);
    
    // Set the value of the input element to the text you want to copy
    tempInput.value = couponCode;
    
    // Select the contents of the input element
    tempInput.select();
    
    const successful = document.execCommand('copy');
    if (successful) {
      selectedElement.textContent = 'Copied!';
    } else {
      selectedElement.textContent = 'Unable to copy!';
    }
    
    // Remove the input element from the DOM
    tempInput.remove();
    
    setTimeout(function() {
      selectedElement.textContent = btnText;
    }, 3000);
  }
})

// When user change product size quick size warning box appear
document.addEventListener('DOMContentLoaded', function() {
  // Get all label elements inside .opt-dropdown li
  const labels = document.querySelectorAll('.other-opt-container label');
  // Add click event listener to each label
  labels.forEach(function(label) {
    label.addEventListener('click', function() {
      // Get the quick size warning element
      const warningBox = document.querySelector('.quick-size-warning');

      // Set display to flex
      if (warningBox) {
        warningBox.style.display = 'flex';
      }
    });
  });
});


//Free Product accordian  

document.addEventListener("DOMContentLoaded", (event) => {
document.querySelectorAll('.free-product-accordion .accordian-title').forEach(function(element) {
  element.addEventListener('click', function() {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
      
      // Animate hide all free-products-list elements
      const freeProductLists = document.querySelectorAll('.template-product .free-product-accordion .free-products-list');
      freeProductLists.forEach(function(list) {
        slideUp(list, 300);
      });
    } else {
      this.classList.add('active');
      
      const tabTitle = this.getAttribute('tab-title');
      console.log(tabTitle);
      
      const tabContent = document.querySelector(`[tab-content="${tabTitle}"]`);
      if (tabContent) {
        slideDown(tabContent, 300);
      }
    }
  });
});
});

// Helper function to animate slide up (hide)
function slideUp(element, duration) {
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';
  element.style.boxSizing = 'border-box';
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight; // Force repaint
  element.style.overflow = 'hidden';
  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;
  
  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
  }, duration);
}

// Helper function to animate slide down (show)
function slideDown(element, duration) {
  element.style.removeProperty('display');
  let display = window.getComputedStyle(element).display;
  if (display === 'none') display = 'block';
  element.style.display = display;
  
  const height = element.offsetHeight;
  element.style.overflow = 'hidden';
  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;
  element.offsetHeight; // Force repaint
  element.style.boxSizing = 'border-box';
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';
  element.style.height = height + 'px';
  element.style.removeProperty('padding-top');
  element.style.removeProperty('padding-bottom');
  element.style.removeProperty('margin-top');
  element.style.removeProperty('margin-bottom');
  
  setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
  }, duration);
}


document.addEventListener("DOMContentLoaded", (event) => {
// Update Text Based on User Click on color  
let laceColor = document.querySelectorAll('.comet-laces .swatches-container input[type="radio"]');
 laceColor.forEach((colorVariant) => {
   colorVariant.addEventListener('change', () => {
     document.querySelector('.comet-laces .swatches .option_selected_value').innerText = colorVariant.value;
   })
 })
})

document.addEventListener("DOMContentLoaded", (event) => {
  function giftproductAddToCart() {
      let gift_product = document.querySelector('.gift-product-wrapper #gift-product');
       if( gift_product != null && gift_product != undefined){
        var gift_product_variant_id = gift_product.value;
       }
      let defaultCartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer');

      function clickHandler() {
          if (gift_product.checked) {
              if (gift_product_variant_id !== '') {
                 let giftProductData = {
                      "items": [{
                          "id": parseInt(gift_product_variant_id),
                          "quantity": 1
                      }],
                      sections: defaultCartDrawer.getSectionsToRender().map((section) => section.id)
                  };
                
                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(giftProductData)
                      })
                      .then(response => {
                          return response.json();
                      }).then(parsedState => {
                          defaultCartDrawer.renderContents(parsedState)
                          document.querySelector('.gift-product-wrapper').style.display="none"
                      })
                      .catch((error) => {
                          console.error('Gift Product Error:', error);
                      });
              }
          } else {
              console.log("CheckBox Unchecked");
          }
      }
    
     if( gift_product != null && gift_product != undefined){
        gift_product.addEventListener('click', clickHandler);
     }
  }
  
  document.addEventListener('cartChange', function () {
    giftproductAddToCart();
  });
    
  giftproductAddToCart();
})

// Gift Product
document.addEventListener('DOMContentLoaded', function() {
  // Get the initially selected variant value
  const checkedRadio = document.querySelector('.template-product .product-form__input.gift-card input[type=radio]:checked');
  let SelectedVariant = checkedRadio ? checkedRadio.value : '';
  
  // Append to the span
  const labelSpan = document.querySelector('.template-product fieldset.product-form__input.gift-card .form__label span');
  if (labelSpan) {
    labelSpan.textContent += SelectedVariant;
  }
  
  // Add click event to all radio buttons
  const radioButtons = document.querySelectorAll('.template-product .product-form__input.gift-card input[type=radio]');
  radioButtons.forEach(function(radio) {
    radio.addEventListener('click', function() {
      // Empty the span
      const span = document.querySelector('.template-product fieldset.product-form__input.gift-card .form__label span');
      if (span) {
        span.textContent = '';
        
        // Get the new selected variant
        const newCheckedRadio = document.querySelector('.template-product .product-form__input.gift-card input[type=radio]:checked');
        SelectedVariant = newCheckedRadio ? newCheckedRadio.value : '';
        
        // Append the new value
        span.textContent += SelectedVariant;
      }
    });
  });
});

//Personalize Custom Field
document.addEventListener("DOMContentLoaded", (event) => {
  // Click the "No" value element
  // Click the "No" value element
  const noElement = document.querySelector('[value="No"]');
  if (noElement) {
      noElement.click();
  }
  // Add click event listeners to accordion elements
  document.querySelectorAll('.personalize-custom-field .personalize-accordian').forEach(function(element) {
      element.addEventListener('click', function() {
          // Click the "Yes" value element
          const yesElement = document.querySelector('[value="Yes"]');
          if (yesElement) {
              yesElement.click();
          }
          
          // Show the personalize-clear element
          document.querySelectorAll('.personalize-clear').forEach(function(el) {
              el.style.display = 'block';
          });
          
          // Add 'active' class to clicked element
          this.classList.add('active');
          
          // Show the corresponding tab content with animation
          const tabTitle = this.getAttribute('tab-title');
          if (tabTitle) {
              const tabContent = document.querySelector(`[tab-content="${tabTitle}"]`);
              if (tabContent) {
                  tabContent.style.display = 'block';
                  tabContent.style.opacity = '0';
                  tabContent.style.transition = 'opacity 300ms';
                  
                  // Force reflow to ensure transition works
                  tabContent.offsetHeight;
                  
                  // Fade in
                  tabContent.style.opacity = '1';
              }
          }
      });
  });

  document.querySelectorAll('.type-your-characters').forEach(function(element) {
    ['change', 'paste', 'keyup'].forEach(function(event) {
        element.addEventListener(event, function() {
            const leftShoeElement = document.getElementById('type-your-characters-left-shoe');
            const rightShoeElement = document.getElementById('type-your-characters-right-shoe');
            
            if (leftShoeElement && rightShoeElement) {
                var LeftValue = leftShoeElement.value;
                var RightValue = rightShoeElement.value;

                if(LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != ''){
                    document.querySelectorAll('.template-product .product-form__buttons button[type="submit"]').forEach(function(button) {
                        button.disabled = true;
                    });
                } else {
                    document.querySelectorAll('.template-product .product-form__buttons button[type="submit"]').forEach(function(button) {
                        button.disabled = false;
                    });
                    document.querySelectorAll('.info-message').forEach(function(infoMsg) {
                        infoMsg.remove();
                    });
                }
            }
        });
    });
  });

  document.querySelectorAll('.personalize-clear').forEach(function(element) {
    element.addEventListener('click', function() {
        // Hide the clicked element
        this.style.display = 'none';
        
        // Click the "No" value element
        const noElement = document.querySelector('[value="No"]');
        if (noElement) {
            noElement.click();
        }
        
        // Hide all personalize-clear elements
        document.querySelectorAll('.personalize-clear').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // Remove 'active' class from accordion elements
        document.querySelectorAll('.personalize-custom-field .personalize-accordian').forEach(function(el) {
            el.classList.remove('active');
        });
        
        // Hide custom field blocks with animation
        document.querySelectorAll('.template-product .personalize-custom-field .custom-field-block').forEach(function(el) {
            el.style.transition = 'opacity 300ms';
            el.style.opacity = '0';
            
            setTimeout(function() {
                el.style.display = 'none';
                el.style.opacity = '1';
            }, 300);
        });
        
        // Uncheck all checked radio buttons
        document.querySelectorAll('.custom-field-block input[type="radio"]:checked').forEach(function(radio) {
            radio.checked = false;
        });
        
        // Clear all type-your-characters input values
        document.querySelectorAll('.type-your-characters').forEach(function(input) {
            input.value = '';
        });
    });
  });

  document.querySelectorAll('.personalize-custom-field .custom-field-block .custom label[for="left-shoe"]').forEach(function(element) {
    element.addEventListener('click', function() {
        // Navigate up to parent's parent with class 'left-right'
        var currentElement = this.parentElement;
        if (currentElement && currentElement.parentElement) {
            var leftRightParent = currentElement.parentElement;
            
            if (leftRightParent.classList.contains('left-right') && leftRightParent.parentElement) {
                // Find siblings with specific classes
                var siblings = Array.from(leftRightParent.parentElement.children).filter(function(child) {
                    return child !== leftRightParent;
                });
                
                siblings.forEach(function(sibling) {
                    if (sibling.classList.contains('custom-field') && sibling.classList.contains('left-shoe')) {
                        // Show with animation
                        sibling.style.display = 'block';
                        sibling.style.opacity = '0';
                        sibling.style.transition = 'opacity 300ms';
                        sibling.offsetHeight; // Force reflow
                        sibling.style.opacity = '1';
                    }
                    if (sibling.classList.contains('custom-field') && sibling.classList.contains('right-shoe')) {
                        // Hide with animation
                        sibling.style.transition = 'opacity 300ms';
                        sibling.style.opacity = '0';
                        setTimeout(function() {
                            sibling.style.display = 'none';
                            sibling.style.opacity = '1';
                        }, 300);
                    }
                });
            }
        }
        
        const leftShoeElement = document.getElementById('type-your-characters-left-shoe');
        const rightShoeElement = document.getElementById('type-your-characters-right-shoe');
        
        if (leftShoeElement && rightShoeElement) {
            var LeftValue = leftShoeElement.value;
            var RightValue = rightShoeElement.value;
            
            if(LeftValue == '' && RightValue == '' || LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != '') {
                document.querySelectorAll('.template-product .product-form__buttons button[type="submit"]').forEach(function(button) {
                    button.disabled = true;
                });
            } else {
                document.querySelectorAll('.template-product .product-form__buttons button[type="submit"]').forEach(function(button) {
                    button.disabled = false;
                });
            }
        }
    });
  });

  document.querySelectorAll('.personalize-custom-field .custom-field-block .custom label[for="right-shoe"]').forEach(function(element) {
    element.addEventListener('click', function() {
        // Navigate up to parent's parent with class 'left-right'
        var currentElement = this.parentElement;
        if (currentElement && currentElement.parentElement) {
            var leftRightParent = currentElement.parentElement;
            
            if (leftRightParent.classList.contains('left-right') && leftRightParent.parentElement) {
                // Find siblings with specific classes
                var siblings = Array.from(leftRightParent.parentElement.children).filter(function(child) {
                    return child !== leftRightParent;
                });
                
                siblings.forEach(function(sibling) {
                    if (sibling.classList.contains('custom-field') && sibling.classList.contains('right-shoe')) {
                        // Show with animation
                        sibling.style.display = 'block';
                        sibling.style.opacity = '0';
                        sibling.style.transition = 'opacity 300ms';
                        sibling.offsetHeight; // Force reflow
                        sibling.style.opacity = '1';
                    }
                    if (sibling.classList.contains('custom-field') && sibling.classList.contains('left-shoe')) {
                        // Hide with animation
                        sibling.style.transition = 'opacity 300ms';
                        sibling.style.opacity = '0';
                        setTimeout(function() {
                            sibling.style.display = 'none';
                            sibling.style.opacity = '1';
                        }, 300);
                    }
                });
            }
        }
        
        const leftShoeElement = document.getElementById('type-your-characters-left-shoe');
        const rightShoeElement = document.getElementById('type-your-characters-right-shoe');
        
        if (leftShoeElement && rightShoeElement) {
            var LeftValue = leftShoeElement.value;
            var RightValue = rightShoeElement.value;
            
            
            if(LeftValue == '' && RightValue == '' || LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != ''){
                document.querySelectorAll('.template-product .product-form__buttons button[type="submit"]').forEach(function(button) {
                    button.disabled = true;
                });
            } else {
                document.querySelectorAll('.template-product .product-form__buttons button[type="submit"]').forEach(function(button) {
                    button.disabled = false;
                });
            }
        }
    });
  });


  document.querySelectorAll('.personalize-custom-field .custom-field-block .custom.left-side label+svg')?.forEach(function(element) {
      element.addEventListener('click', function() {
          // Uncheck all checked radio buttons in left-side
          document.querySelectorAll('.custom-field-block .custom.left-side input[type="radio"]:checked')?.forEach(function(radio) {
              radio.checked = false;
          });
          
          // Clear the value of type-your-characters input in left-shoe
          document.querySelectorAll('.custom-field.left-shoe .type-your-characters')?.forEach(function(input) {
              input.value = '';
          });
      });
  });

  document.querySelectorAll('.personalize-custom-field .custom-field-block .custom.right-side label+svg')?.forEach(function(element) {
    element.addEventListener('click', function() {
        // Uncheck all checked radio buttons in right-side
        document.querySelectorAll('.custom-field-block .custom.right-side input[type="radio"]:checked')?.forEach(function(radio) {
            radio.checked = false;
        });
        
        // Clear the value of type-your-characters input in right-shoe
        document.querySelectorAll('.custom-field.right-shoe .type-your-characters')?.forEach(function(input) {
            input.value = '';
        });
    });
  });
});


// Selected Variant Content Display
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.opt-dropdown li label').forEach(function(element) {
        element.addEventListener('click', function() {
            // Find sibling input element and get its value
            var siblingInput = null;
            var siblings = this.parentElement ? Array.from(this.parentElement.children) : [];
            
            for (var i = 0; i < siblings.length; i++) {
                if (siblings[i] !== this && siblings[i].tagName === 'INPUT') {
                    siblingInput = siblings[i];
                    break;
                }
            }
            
            if (siblingInput) {
                var SelectedVariant = siblingInput.value;
                
                // Check if variant-specific content exists
                var variantContent = document.querySelector(`.quick-size-warning p.variant-content[data-variant="${SelectedVariant}"]`);
                
                if (variantContent) {
                    // Hide size warning
                    document.querySelectorAll('.quick-size-warning p.size-warning').forEach(function(el) {
                        el.style.display = 'none';
                    });
                    
                    // Remove 'show' class from all variant contents
                    document.querySelectorAll('.quick-size-warning p.variant-content').forEach(function(el) {
                        el.classList.remove('show');
                    });
                    
                    // Add 'show' class to selected variant content
                    variantContent.classList.add('show');
                } else {
                    // Remove 'show' class from all variant contents
                    document.querySelectorAll('.quick-size-warning p.variant-content').forEach(function(el) {
                        el.classList.remove('show');
                    });
                    
                    // Show size warning
                    document.querySelectorAll('.quick-size-warning p.size-warning').forEach(function(el) {
                        el.style.display = 'block';
                    });
                }
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", (event) => {
function giftModules() {
    const g_cart_edit_option = document.querySelectorAll('.gift-product-wrapper');
    const cart_quantity_btn = document.querySelectorAll('.cart-item__quantity .quantity__input');
    const cart_url = `/cart.json`;
    const cart_change_url = `${window.Shopify.routes.root}cart/change.js`;
    const cart_update_url = `${window.Shopify.routes.root}cart/update.js`;
    const cart_post_url = `${window.Shopify.routes.root}cart/add.js`;
    
    // Get Cart Data
    const fetchCartData = async () => {
      try {
        const response = await fetch(cart_url);
        if (!response.ok) throw new Error("Can't get Cart data");
        const cart_data = await response.json();
        return cart_data;
      } catch (err) {
        console.error("Error Occur Dude", err);
        return null;
      }
    };
  
    
  // Remove Cart Note if goft product not in the cart
    let remove_cart_notes = async () => {
      try{
         let CartData = await fetchCartData();
          if(!CartData){
            throw Error("Something Wrong when get cart data inside remove_cart_notes function")
          }

          let is_cart_contain_gift = CartData['items'].some((cart_items) => cart_items.properties.hasOwnProperty('_gift_wrap') && cart_items.properties['_gift_wrap'] == false || cart_items.properties['_gift_wrap'] == "false");
          let item_length = CartData['items'].length;

          if(is_cart_contain_gift || item_length == 0){
            let update_cart_notes = {
              note: '',
              attributes: {
                "note":''
              },
            }
  
            let update_note_in_cart =  await fetch(cart_update_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(update_cart_notes)
            })
  
            if(!update_note_in_cart.ok){
              throw Error('Error Occur When Update Cart Not If gift product not in a cart');
            }

            let updated_cart_data = update_note_in_cart.json();
            return updated_cart_data;
          }
      }catch(error){
        console.log(error)
      }                   
    }
  
    // Update Line-item Property When gift product add to cart
    const updateCartItemProperty = async (productDetails) => {
      const d_CartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer');
      const error_msg_wrapper = document.querySelector(`.cart-item[data-item-key ="${productDetails.line_item_key}"] .cart-item__error-text`) || document.querySelector(`[data-item-key="${productDetails.line_item_key}"] .cart-drawer-v2__item-error small`);

      // Fetch current cart to get existing properties
      const cartData = await fetchCartData();
      const currentItem = cartData.items.find(item => item.key === productDetails.line_item_key);
      const existingProperties = currentItem?.properties || {};

      // Merge existing properties with _gift_wrap
      const mergedProperties = {
        ...existingProperties,
        "_gift_wrap": true
      };

      const updates = {
        "id": productDetails.line_item_key,
        'quantity': productDetails.line_item_quantity,
        "properties": mergedProperties,
        sections: d_CartDrawer.getSectionsToRender().map(section => section.id),
      };
      try {
        const response = await fetch(cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updates)
        });
  
        if (!response.ok) {
          const res = await response.json();
          error_msg_wrapper.innerHTML = res['message'];
          throw new Error(res.message);
        }
  
        const update_cart_data = await response.json();
        d_CartDrawer.renderContents(update_cart_data);
      } catch (err) {
        console.error(err);
        return null;
      }
    };
  
    
    // Add gift Product to cart when Gift checkbox is checked 
      const addProductToCart = async (productDetails, gift_product_variant_id, gift_product_variant_price) => {
      const error_msg_wrapper = document.querySelector(`.cart-item[data-item-key ="${productDetails.line_item_key}"] .cart-item__error-text`);
      const cart_notes = gift_product_variant_price;
      const cart_attribute_notes = `| Gift wrap - True | Item Value - ${gift_product_variant_price}`;
      const freeProductData = {
        "items": [{
          "id": parseInt(gift_product_variant_id),
          "quantity": productDetails.line_item_quantity,
          "properties": { "_gift_wrap": productDetails.variant_title, "_gift_hide_quantity": true }
        }],
        note: cart_notes,
        attributes: {
         note: cart_attribute_notes
        }
      };
  
      try {
        document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
        const response = await fetch(cart_post_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(freeProductData)
        });
  
        if (!response.ok) {
          const res = await response.json();
          if(res.status == 422){
             error_msg_wrapper.innerHTML = 'You can\'t add more Test Gift Wrap to the cart.';
          }else{
             error_msg_wrapper.innerHTML = res['message']
          }
          throw new Error(res.message);
        }
  
        const cart_response = await response.json();
        return await updateCartItemProperty(productDetails);
      } catch (err) {
        console.error(err);
        document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
        return null;
      }
    };
    // Add gift Product cart when cart checkbox is checked End
  
  // Function to find the gift pair in the cart
    const find_gift_pair = async (c_line_item_key) => {
      const result = await fetchCartData();
      
      if (!result || !result.items) {
        console.error("missing cart items array");
        return null;
      }
    
      const c_line_item = result.items.find(item => item.key === c_line_item_key);
      console.log(c_line_item, 'c_line_item');
    
      if (!c_line_item) {
        console.error("Current line item not found");
        return null;
      }
    
      const line_item_key = c_line_item.title;
      const g_wrap_paper = result.items.find(item => item.properties['_gift_wrap'] === line_item_key);
    
      if (!g_wrap_paper) {
        return null;
      }
    
      return {
        'gifted_product': c_line_item.key,
        'gift_paper': g_wrap_paper.key
      };
    };
  
    
  // Function to remove gift wrap pair
  const removeGiftWrapPair = async (current_line_item_key, cart_update_url, cart_change_url, current_line_item_quantity='1') => {
      try {
        const keys = await find_gift_pair(current_line_item_key);
        document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
        if (!keys){
           document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
           return;
        }
    
        // Selecting cart drawer || Notification Element
        const d_CartDrawer = document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        if (!d_CartDrawer) {
          console.error("Cart drawer or notification element not found");
          document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
          return;
        }
    
        // Object to hold updates for removing gift paper
        let updates = {
          [keys.gift_paper]: 0,
        };
    
        // Function to remove gift paper from the cart
        const remove_gift_paper = async () => {
          try {
            const response = await fetch(cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
    
            if (!response.ok) {
              const res = await response.json();
              throw new Error(res.message);
            }
            
            return await response.json();
            
          } catch (err) {
            console.error(err);
             document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
            return null;
          }
        };
          
        // Fetch current cart to get existing properties before removing gift wrap
        const cartDataBeforeRemove = await fetchCartData();
        const currentItemBeforeRemove = cartDataBeforeRemove.items.find(item => item.key === keys.gifted_product);
        const existingPropertiesBeforeRemove = currentItemBeforeRemove?.properties || {};

        // Merge existing properties with _gift_wrap: false to preserve all other properties (like Size)
        const mergedPropertiesAfterRemove = {
          ...existingPropertiesBeforeRemove,
          "_gift_wrap": false
        };

        // Object to hold updates for removing line item properties
        const props_updates = {
          id: keys.gifted_product,
          quantity: current_line_item_quantity,
          properties: mergedPropertiesAfterRemove,
          sections: d_CartDrawer.getSectionsToRender().map(section => section.id)
        };

        // Function to remove line item properties from the cart
        var cart_new_data = null;
        const remove_line_item_props = async () => {
          try {
            const response = await fetch(cart_change_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(props_updates)
            });

            if (!response.ok) {
              const res = await response.json();
              throw new Error(res.message);
            }

            cart_new_data = await response.json();

            console.log(cart_new_data, "cart_new_data")
            d_CartDrawer.renderContents(cart_new_data);
          } catch (err) {
            console.error(err);
            document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
            return null;
          }
        };
    
        // Sequential call to remove gift paper and then update line item properties
        await remove_gift_paper();
        await remove_line_item_props();
        console.log(cart_new_data, "HEHEH")
        const hasGiftWrap = cart_new_data['items'].some(item => item.properties && item.properties._gift_wrap === true);
        if(!hasGiftWrap){
          await remove_cart_notes();
        }
      } catch (err) {
        console.error(err);
      }
  };
    
  
    g_cart_edit_option.forEach((current_g_cart_edit_option) => {
      const inputField = current_g_cart_edit_option.querySelector('input[id^="gift-pro-option-list-"]');
      if (!inputField.dataset.listenerAdded) {
        inputField.addEventListener('change', async (event) => {
          const optionValue = event.target.checked;
          const productDetails = {
            productHandle: event.target.dataset.productHandle,
            variant_title: event.target.dataset.variantTitle,
            line_item_key: event.target.dataset.lineItemKey,
            line_item_quantity: event.target.dataset.lineItemQuantity,
            gift_variant_id: event.target.dataset.giftVariantId,
            gift_variant_price: 0//event.target.dataset.giftVariantPrice
          };
          if (optionValue) {
            // const gift_product_variant_id = window.free_gift_product['variant_id'];
            const gift_product_variant_id = productDetails['gift_variant_id'];
            const gift_product_variant_price = productDetails['gift_variant_price'];
            await addProductToCart(productDetails, gift_product_variant_id, gift_product_variant_price);
            inputField.checked = false;
          }else{ 
              const current_line_item_key = productDetails.line_item_key;
              console.log(current_line_item_key, 'current_line_item_key');
              const current_line_item_quantity = productDetails['line_item_quantity'];
              removeGiftWrapPair(current_line_item_key, cart_update_url, cart_change_url, current_line_item_quantity);      
          }
          console.log(productDetails, "productDetails")
        });
  
        inputField.dataset.listenerAdded = true;
      }
    });
    
  if(cart_quantity_btn){
    cart_quantity_btn.forEach((quantity_btn) => {
      quantity_btn.addEventListener('change', async (event) => {
  
        // Function to find the parent element with the data-item-key attribute
        const findParentWithDataItemKey = (element) => {
          while (element && !element.hasAttribute('data-item-key')) {
            element = element.parentElement;
          }
          return element;
        };
  
        const parentElement = findParentWithDataItemKey(event.target);
        const c_l_item_key = parentElement.dataset.itemKey;
  
        if(Number(event.target.value) == 0 && c_l_item_key) {
          try{
            let get_gift_paper = await find_gift_pair(c_l_item_key);
            if (!get_gift_paper) return;
            document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
            const defaultCartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer');
            let updates = {
              'id': get_gift_paper.gift_paper,
              'quantity': 0,
              'sections': defaultCartDrawer.getSectionsToRender().map(section => section.id)
            }


            var without_gift_data = null;
            const remove_gift_paper = async () => {
              try {
                const response = await fetch(cart_change_url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(updates)
                });
        
                if (!response.ok) {
                  const res = await response.json();
                  throw new Error(res.message);
                }
                without_gift_data = await response.json();
                // document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
                defaultCartDrawer.renderContents(without_gift_data);
                if(!without_gift_data['items'].length){
                  defaultCartDrawer.classList.add('is-empty');
                }
             
                
              } catch (err) {
                console.error(err);
                return null;
              }
            };
            
            // setTimeout(async () => {
                document.addEventListener('cart:qty:change', async() => {
                  document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
                  await remove_gift_paper();  
                  // await remove_cart_notes();
                  const hasGiftWrap = without_gift_data['items'].some(item => item.properties && item.properties._gift_wrap === true);
                  if(!hasGiftWrap){
                    console.log("EXECUTED")
                    await remove_cart_notes();
                  }
                })
            // }, 3000)
            
          }catch(error){
            console.log(error)
          }
        }
      });
    });
  }
}

giftModules();

// Function to update product quantity in the cart with error handling using try-catch
async function updateProductQuantity(item_list) {
  try {
    document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
    const d_CartDrawer = document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const sections = d_CartDrawer.getSectionsToRender().map(section => section.id);
    if (!d_CartDrawer) {
      console.error("Cart drawer or notification element not found");
      document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
      return;
    }
    let updates = {};
    item_list.forEach(item => {
      updates[item.gift_wrap_key] = item.main_variant_qty;
    });

    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({updates, sections}) 
    });

    if (!response.ok) {
      throw new Error(`Failed to update item quantity. Status: ${response.status}`);
    }
    const data = await response.json();
    document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
    d_CartDrawer.renderContents(data);
  } catch (error) {
    console.error("Error updating cart item:", error.message);
    document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
  }
}

document.addEventListener('cartChange', () => {
  giftModules();
});

document.addEventListener('cart:qty:change', async (e) => {
  const line_item_qty = e.detail.newQty;
  if(line_item_qty > 0){
    try {
      // Fetch current cart data
      const response = await fetch('/cart.js');
      const data = await response.json();
    
      if (data['items'].length) {
        // Filter for main products: 
        const mainProducts = data['items'].filter(item => 
          item.properties && Object.keys(item.properties).length > 0 && // Check if properties is not an empty object
          ((item.properties['_gift_wrap'] && item.properties['_gift_wrap'] == true))
        );

        if (mainProducts.length) {
            const matchedGiftWraps = [];
            // Loop through main products and find their related gift wrap line items
            mainProducts.forEach(mainItem => {
              data.items.forEach(cartItem => {
                if (cartItem.properties && cartItem.properties['_gift_wrap'] === mainItem.title) {
                  matchedGiftWraps.push({
                    main_variant_qty: mainItem.quantity,
                    main_variant_title: mainItem.title,
                    gift_wrap_key: cartItem.key
                  });
                }
              });
            });
            if(matchedGiftWraps.length){
              updateProductQuantity(matchedGiftWraps);
            }
        }
      }
    } catch (error) {
      // Handle error if needed
          console.error('Error fetching cart data:', error);
          document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
    }
  }
});

  
let color_swatch_func = () => {
  let swatch_show_more = document.querySelector('.moreless-button');
  let swatch_drawer = document.querySelector('.color-swatch-drawer');
  let swatch_drawer_inner = document.querySelector('.color-swatch-drawer-inner');
  let swatch_drawer_close = document.querySelector('.color-swatch-drawer .color-swatch-drawer-header button');
  let doc_body = document.querySelector('body');
  
    if(swatch_show_more && swatch_drawer){
        swatch_show_more.addEventListener('click', (e) => {
          e.preventDefault();
          swatch_drawer.classList.add('active');
          doc_body.classList.add('overflow-hidden', 'color-swatch-active')
        })
    
        swatch_drawer.addEventListener('click', () => {
          swatch_drawer.classList.remove('active');
           doc_body.classList.remove('overflow-hidden', 'color-swatch-active')
        });
        
        swatch_drawer_inner.addEventListener('click', (event) => {
            event.stopPropagation(); 
        });
  
       if(swatch_drawer_close){
          swatch_drawer_close.addEventListener('click', () => {
             swatch_drawer.classList.remove('active');
              doc_body.classList.remove('overflow-hidden', 'color-swatch-active')
          })
        }  
    }


     const labels = document.querySelectorAll('.swatches-image.lace-products');
        labels.forEach(label => {
          label.addEventListener('click', function() {
            // Find the corresponding radio input using the 'for' attribute of the label
            const inputId = this.getAttribute('for');
            const inputToCheck = document.querySelector(`#${inputId}`);
             labels.forEach(labeled => {
              labeled.classList.remove('i_checked');
             })
            
             label.classList.add('i_checked');
          });
      }); 
}
color_swatch_func(); 

// Function to apply the animation to the checked inputs
function applyAnimationToCheckedInputs() {
  // Apply animation to checked inputs
  document.querySelectorAll('.swatches-container.color-multi input[type="radio"]:checked').forEach(input => {
    const inputId = input.id;

    // Find all radio inputs with the same id
    document.querySelectorAll(`.swatches-container.color-multi input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
      // Find the corresponding label using the 'for' attribute
      const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
      if (label && label.querySelector('img')) {
        // Apply the rotation and transition
        const img = label.querySelector('img');
        img.style.transition = 'all .3s ease-in-out';
        img.style.transform = 'rotate(340deg)';
      }
    });
  });
}

// Event listener for changes to radio inputs
function setupChangeInputListener() {
  document.querySelectorAll('.swatches-container.color-multi input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
      const inputId = this.id;

      // Set the checked state for both original and duplicate inputs
      document.querySelectorAll(`.swatches-container.color-multi input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
        duplicateInput.checked = true;

        // Find the corresponding label using the 'for' attribute
        const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
        if (label && label.querySelector('img')) {
          // Apply the rotation and transition
          label.querySelector('img').style.transition = 'all .3s ease-in-out';
          label.querySelector('img').style.transform = 'rotate(340deg)';
        }
      });
    });
  });
}
  
function applyAnimationToCheckedInputsLaces() {
  // Apply animation to checked inputs
  document.querySelectorAll('.comet-laces .swatches-container input[type="radio"]:checked').forEach(input => {
    const inputId = input.id;

    // Find all radio inputs with the same id
    document.querySelectorAll(`.comet-laces .swatches-container input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
      // Find the corresponding label using the 'for' attribute
      const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
      if (label) {
        label.style.borderColor = '#ebef29!important';
      }
    });
  });
}

// Event listener for changes to radio inputs
function setupChangeInputListenerLaces() {
  document.querySelectorAll('.comet-laces .swatches-container input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
      const inputId = this.id;

      // Set the checked state for both original and duplicate inputs
      document.querySelectorAll(`.comet-laces .swatches-container input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
        duplicateInput.checked = true;

        // Find the corresponding label using the 'for' attribute
        const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
        if (label) {
          label.style.borderColor = '#ebef29!important';
        }
      });
    });
  });
}

// Apply animation to checked inputs on page load

setupChangeInputListener();
applyAnimationToCheckedInputs();
setupChangeInputListenerLaces();
applyAnimationToCheckedInputsLaces();


// Handle AJAX content rendering
document.addEventListener("ajaxloader:render", function() {
  // Assuming this function is needed for AJAX content
  color_swatch_func();
  setupChangeInputListener();
  applyAnimationToCheckedInputs();
  setupChangeInputListenerLaces();
  applyAnimationToCheckedInputsLaces();
});

  
});


// Collection Page Grid list 
document.addEventListener("DOMContentLoaded", (event) => {
  // Check localStorage for saved view preference
  if (localStorage.getItem('productView') === 'list') {
      // Add 'active' class to facet filters
      document.querySelectorAll('.facets-container .facet-filters-containy').forEach(function(el) {
          el.classList.add('active');
      });
      
      // Add 'grid__custom_listy' class to product grid containers
      document.querySelectorAll('.product-grid-container .collection .pro__grid__list_containerz').forEach(function(el) {
          el.classList.add('grid__custom_listy');
      });
  } else {
      // Remove 'active' class from facet filters
      document.querySelectorAll('.facets-container .facet-filters-containy').forEach(function(el) {
          el.classList.remove('active');
      });
      
      // Remove 'grid__custom_listy' class from product grid containers
      document.querySelectorAll('.product-grid-container .collection .pro__grid__list_containerz').forEach(function(el) {
          el.classList.remove('grid__custom_listy');
      });
  }

  // Handle list view button click
  document.querySelectorAll('.grid__products_style_btn_list svg').forEach(function(element) {
      element.addEventListener('click', function() {
          // Add 'active' class to facet filters
          document.querySelectorAll('.facets-container .facet-filters-containy').forEach(function(el) {
              el.classList.add('active');
          });
          
          // Add 'grid__custom_listy' class to product grid containers
          document.querySelectorAll('.product-grid-container .collection .pro__grid__list_containerz').forEach(function(el) {
              el.classList.add('grid__custom_listy');
          });
          
          // Save the preference to localStorage
          localStorage.setItem('productView', 'list');
          
          // Refresh slick slider position
          document.querySelectorAll('.grid-image-slider').forEach(function(slider) {
              if (slider.slick && typeof slider.slick.setPosition === 'function') {
                  slider.slick.setPosition();
              }
          });
      });
  });

  // Handle grid view button click
  document.querySelectorAll('.grid__products_style_btn_grid svg').forEach(function(element) {
    element.addEventListener('click', function() {
        // Remove 'active' class from facet filters
        document.querySelectorAll('.facets-container .facet-filters-containy').forEach(function(el) {
            el.classList.remove('active');
        });
        
        // Remove 'grid__custom_listy' class from product grid containers
        document.querySelectorAll('.product-grid-container .collection .pro__grid__list_containerz').forEach(function(el) {
            el.classList.remove('grid__custom_listy');
        });
        
        // Save the preference to localStorage
        localStorage.setItem('productView', 'grid');
        
        // Refresh slick slider position
        document.querySelectorAll('.grid-image-slider').forEach(function(slider) {
            if (slider.slick && typeof slider.slick.setPosition === 'function') {
                slider.slick.setPosition();
            }
        });
    });
});

  // show 2 items per row
  // Add 'active' class to grid_4 button
document.querySelectorAll('.grid__products_style_btn_grid_4').forEach(function(el) {
    el.classList.add('active');
});

// Add click event listener to grid_2 button SVGs
document.querySelectorAll('.grid__products_style_btn_grid_2 svg').forEach(function(element) {
    element.addEventListener('click', function() {
        // Find the closest parent with class 'grid__products_style_btn_grid_2'
        const parent = this.closest('.grid__products_style_btn_grid_2');
        
        if (parent) {
            // Add 'active' class to parent
            parent.classList.add('active');
            
            // Remove 'active' class from siblings
            if (parent.parentElement) {
                Array.from(parent.parentElement.children).forEach(function(sibling) {
                    if (sibling !== parent) {
                        sibling.classList.remove('active');
                    }
                });
            }
        }
        
        // Add 'grid_2' class and remove 'grid_4' class from product grid containers
        document.querySelectorAll('.product-grid-container .collection .pro__grid__list_containerz').forEach(function(el) {
            el.classList.add('grid_2');
            el.classList.remove('grid_4');
        });
        
        // Refresh slick slider position
        document.querySelectorAll('.grid-image-slider').forEach(function(slider) {
            if (slider.slick && typeof slider.slick.setPosition === 'function') {
                slider.slick.setPosition();
            }
        });
    });
});

  // show 4 items per row
  document.querySelectorAll('.grid__products_style_btn_grid_4 svg').forEach(function(element) {
    element.addEventListener('click', function() {
        // Find the closest parent with class 'grid__products_style_btn_grid_4'
        const parent = this.closest('.grid__products_style_btn_grid_4');
        
        if (parent) {
            // Add 'active' class to parent
            parent.classList.add('active');
            
            // Remove 'active' class from siblings
            if (parent.parentElement) {
                Array.from(parent.parentElement.children).forEach(function(sibling) {
                    if (sibling !== parent) {
                        sibling.classList.remove('active');
                    }
                });
            }
        }
        
        // Add 'grid_4' class and remove 'grid_2' class from product grid containers
        document.querySelectorAll('.product-grid-container .collection .pro__grid__list_containerz').forEach(function(el) {
            el.classList.add('grid_4');
            el.classList.remove('grid_2');
        });
        
        // Refresh slick slider position
        document.querySelectorAll('.grid-image-slider').forEach(function(slider) {
            if (slider.slick && typeof slider.slick.setPosition === 'function') {
                slider.slick.setPosition();
            }
        });
    });
});

});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        // Add 'jdgm-histogram__row--selected' class to histogram rows with data-rating="null"
        document.querySelectorAll('.template-product #judgeme_product_reviews .jdgm-rev-widg__header .jdgm-row-stars .jdgm-histogram .jdgm-histogram__row[data-rating="null"]').forEach(function(el) {
            el.classList.add('jdgm-histogram__row--selected');
        });
    }, 1000);
});


document.addEventListener("DOMContentLoaded", function() {
    function videoLazyLoad() {  
         let lazyVideos = [...document.querySelectorAll("video.video_lazy_load.lazy")]
          if(lazyVideos){
             if ("IntersectionObserver" in window) {
               let lazyVideoObserver = new IntersectionObserver(function(entries) {
                 entries.forEach(function(video) {
                   if (video.isIntersecting) {
                     for (let source in video.target.children) {
                       let videoSource = video.target.children[source];
                       if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                         videoSource.src = videoSource.dataset.src;
                       }
                     }
            
                     video.target.load();
                     video.target.classList.remove("lazy");
                     lazyVideoObserver.unobserve(video.target);
                   }
                 });
               });
            
               if(lazyVideos){
                 lazyVideos.forEach(function(lazyVideo) {
                   lazyVideoObserver.observe(lazyVideo);
                 });
               }
             }
          }
    }
  
  videoLazyLoad();
  document.addEventListener("ajaxloader:render", videoLazyLoad);

    let swatches_hide = () => {
    document.addEventListener('product:variant:changed', (event) => {
       let productId = document.querySelector('variant-radios')?.dataset.productId;

       if (productId === undefined) return;
       if(event.detail['variant']){
          let currentVariant = event.detail['variant']['options'];
          findSoldoutOptions(window.product_object, currentVariant, productId);
       }
    });
    
   document.addEventListener('previous:product:variant', (event) => {
     let productId = event.detail['product_variant'] || document.querySelector('variant-radios')?.dataset.productId;
     if (productId === undefined) return;
       if(event.detail['currentVariant'] && event.detail['variantData'].length){
         let variantId = event.detail['currentVariant'];
         let variantList = event.detail['variantData'];
         let currentSelectedvariant = variantList.filter(variant => variant.id == variantId);
         let currentVariantOption = currentSelectedvariant[0]['options'];
         document.addEventListener("ajaxloader:load",function(){
          findSoldoutOptions(window.product_object, currentVariantOption, productId);
         });
       }
   });  
  }

  function findSoldoutOptions(colorProducts = [], currentVariant, currentProductId){
    let swatchesLabels = document.querySelectorAll('.product-swatch-options .swatches-image');
    
    if (colorProducts.length && currentVariant.length && swatchesLabels.length) {
        swatchesLabels.forEach((swatcheLabel) => {
          swatcheLabel.classList.remove('hide-swatch');
        });

        let withOutCurrentProduct = colorProducts.filter(product => product.id != currentProductId);

          let matchedSwatches = [];
            withOutCurrentProduct.forEach((product) => {
                let hasMatchingSize = product.variants.some((variant) => {
                    return currentVariant.some(option => variant['options'].includes(option));
                });
    
                if (!hasMatchingSize) {
                    // If product doesn't include the selected size, add it to matchedSwatches
                    matchedSwatches.push(product);
                } else {
                    // Check if size exists but is unavailable
                    product.variants.forEach((variant) => {
                        if (
                            currentVariant.some(option => variant['options'].includes(option)) &&
                            variant['available'] === false &&
                            variant['inventory_management'] == "shopify" &&
                            variant['inventory_policy'] == "deny"
                        ) {
                            matchedSwatches.push(product);
                        }
                    });
                }
          });
         //Get available products
          let remainingSwatches = colorProducts.filter(product => 
            !matchedSwatches.includes(product)
          );
      
          hide_swatch(matchedSwatches, remainingSwatches);
    } else {
        console.log("No product data found");
    }
  }
  
  function hide_swatch(matchedVariant = [], availableProducts = []){
    let swatchesToShow = document.querySelector('.product-swatch-options .swatches-container')?.dataset.colorToShow || 4;
      if(matchedVariant.length){
        
        // Hide swatches which is not available
          matchedVariant.forEach((swatcheLabel) => {
              const swatchElements = document.querySelectorAll(`.swatches-image[data-pro-handle="${swatcheLabel.product_handle}"]`);
              if (swatchElements.length > 0) {
                  swatchElements.forEach((element) => {
                    element.classList.add('hide-swatch');
                  });
              } else {
                  console.warn(`No swatch elements found for product_handle: ${swatcheLabel.product_handle}`);
              }
          });
       }
        // show swatches which is available but limited to show
        if(availableProducts.length){
            availableProducts.forEach((swatcheLabel, index) => {
                  const limitedSwatchElements = document.querySelectorAll(`.swatches-image.swatches-label[data-pro-handle="${swatcheLabel.product_handle}"]`);
                  if (limitedSwatchElements.length > 0 && index < Number(swatchesToShow)) {
                      limitedSwatchElements.forEach((element, currentIndex) => {
                        element.classList.remove('hide-swatch');
                      });
                  } else {
                      limitedSwatchElements.forEach((element) => {
                        element.classList.add('hide-swatch');
                      });
                  }
                
            });
      } 
  }
  
  swatches_hide();
  document.addEventListener("ajaxloader:render", swatches_hide);


 // Update Inventory Stocks
if(window.inventory_details){
  for(let i in window.inventory_details){
    const inp = document.querySelector(`input[name="Size"][value="${i}"]`);
    if(inp){
      inp.nextElementSibling.querySelector('.inventory-count').innerHTML = window.inventory_details[i];
      if(window.restock_available[i]){
        inp.nextElementSibling.querySelector('.inventory-count').classList.add('restock_alert');
      }
    }
  }
}
  
});